/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for bridger surveys per equipment type
 * @export
 * @interface BridgerSurveyStats
 */
export interface BridgerSurveyStats {
    /**
     * 
     * @type {string}
     * @memberof BridgerSurveyStats
     */
    equipmentName: string;
    /**
     * 
     * @type {number}
     * @memberof BridgerSurveyStats
     */
    emissionCount: number;
    /**
     * 
     * @type {number}
     * @memberof BridgerSurveyStats
     */
    emissionSum: number;
}

/**
 * Check if a given object implements the BridgerSurveyStats interface.
 */
export function instanceOfBridgerSurveyStats(value: object): value is BridgerSurveyStats {
    if ((!('equipmentName' in (value as Record<string, any>)) && !('equipment_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['equipmentName'] === undefined && (value as Record<string, any>)['equipment_name'] === undefined)) return false;
    if ((!('emissionCount' in (value as Record<string, any>)) && !('emission_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionCount'] === undefined && (value as Record<string, any>)['emission_count'] === undefined)) return false;
    if ((!('emissionSum' in (value as Record<string, any>)) && !('emission_sum' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionSum'] === undefined && (value as Record<string, any>)['emission_sum'] === undefined)) return false;
    return true;
}

export function BridgerSurveyStatsFromJSON(json: any): BridgerSurveyStats {
    return BridgerSurveyStatsFromJSONTyped(json, false);
}

export function BridgerSurveyStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgerSurveyStats {
    if (json == null) {
        return json;
    }
    return {
        
        'equipmentName': json['equipment_name'],
        'emissionCount': json['emission_count'],
        'emissionSum': json['emission_sum'],
    };
}

export function BridgerSurveyStatsToJSON(json: any): BridgerSurveyStats {
    return BridgerSurveyStatsToJSONTyped(json, false);
}

export function BridgerSurveyStatsToJSONTyped(value?: BridgerSurveyStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'equipment_name': value['equipmentName'],
        'emission_count': value['emissionCount'],
        'emission_sum': value['emissionSum'],
    };
}

